import gql from "graphql-tag";

export const CALCULATE_PREMIUM = gql`
  query calculatePremium($input: CalculatePremiumInput!) {
    calculatePremium(input: $input) {
      actualPremium {
        formatted
        raw
      }
      discountedPremium {
        formatted
        raw
      }
      formattedPremium
    }
  }
`;
